import { MUT_ALTERS } from "./mut-columns.js";

export const recurrenceTable = `
CREATE TABLE IF NOT EXISTS recurrence_rules (
  id          TEXT PRIMARY KEY,
  rrule       TEXT NOT NULL,
  dtstart     TEXT NOT NULL,
  until       TEXT,
  tz          TEXT,
  exdates     TEXT NOT NULL DEFAULT '[]',
  mut         INTEGER NOT NULL DEFAULT 0,
  server_acked_mut INTEGER NOT NULL DEFAULT 0,
  google_acked_mut INTEGER NOT NULL DEFAULT 0,
  created_at  TEXT NOT NULL,
  updated_at  TEXT NOT NULL,
  deleted_at  TEXT
);
`.trim();

/** ALTER statements to bring an existing recurrence_rules table up to schema.
 *  Each is wrapped in try/catch by migrate() (re-adding a column errors). */
export const recurrenceAlters = [
  "ALTER TABLE recurrence_rules ADD COLUMN tz TEXT;",
  ...MUT_ALTERS("recurrence_rules"),
];
